import TheGrid from '@/views/campaigns/extra/grid'
import Edit from '@/views/campaigns/extra/edit'
import TheImport from '@/views/campaigns/extra/import'

export default {
  path: '/campaigns/extra',
  redirect: '/campaigns/extra/index',
  name: 'extra',
  meta: {
    auth: {
      redirect: {
        name: 'extra.index'
      },
      forbiddenRedirect: '/dashboard'
    },
    label: 'Critérios'
  },
  component: {
    render(c) {
      return c('router-view')
    }
  },
  children: [{
    path: 'index',
    name: 'extra.index',
    component: TheGrid,
    meta: {
      auth: true,
      label: 'Lista'
    }
  }, {
    path: 'create',
    name: 'extra.create',
    component: Edit,
    meta: {
      auth: true,
      label: 'Criar'
    }
  }, {
    path: 'import',
    name: 'extra.import',
    component: TheImport,
    meta: {
      auth: true,
      label: 'Importar'
    }
  }, {
    path: 'edit/:id',
    name: 'extra.edit',
    component: Edit,
    meta: {
      auth: true,
      label: 'Editar'
    }
  }]
}
